import React, { createContext, useContext, useState, useEffect } from 'react';
import { defaultDropdownConfig } from '../../services/GlobalFuction';
import { GetAllDepartment } from '../../utils/apiCalls';

const StaffContext = createContext();

export const useDepartment = () => useContext(StaffContext);

export const StaffProvider = ({ children }) => {
    const [departmentList, setDepartmentList] = useState([]);

    const fetchAllDepartments = () => {
        GetAllDepartment((res) => {
            const { statusCode, data } = res;
            const departments =
                statusCode === 200
                    ? data?.map((item) => ({
                        label: item.departmentName,
                        value: item.departmentId,
                    }))
                    : [];
            setDepartmentList(departments);
        }, defaultDropdownConfig);
    };

    useEffect(() => {
        fetchAllDepartments();
    }, []);

    return (
        <StaffContext.Provider value={{ departmentList }}>
            {children}
        </StaffContext.Provider>
    );
};
